import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      {/* Top gradient line */}
      <div className="footer-gradient-line" />

      <div className="footer-container">
        <div className="footer-links">
          <a href="https://www.syntriq.in/contact">Contact Us</a>
          <a href="https://certificates.syntriq.in/terms#:~:text=Voluntary%20Contribution%20and%20Non%2DRefundable%20Nature">Refund Policy</a>
          <a href="https://certificates.syntriq.in/terms">Terms and Conditions</a>
          <a href="mailto:support@syntriq.in">support@syntriq.in</a>
        </div>
        <p>&copy; {new Date().getFullYear()} Syntriq Technologies. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
